import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import MusicPreviewBtn, {
  MusicPreviewBtnDisable,
} from '../../../../components/music/MusicPreviewBtn';
import {IDemoScriptStateProp} from '../../../../dto/demoStingerFulfilment.dto';
import DemoStingerFileUpload from './DemoStingerFileUpload';
type Props = {
  message: IDemoScriptStateProp[];
  setMessage: React.Dispatch<React.SetStateAction<IDemoScriptStateProp[]>>;
  taskSlug?: string;
  requestType?: number;
};
const DemoStingerAddAudio = ({
  message,
  setMessage,
  taskSlug,
  requestType,
}: Props) => {
  return (
    <TableContainer className='overflow-auto scrollbar h-full max-h-560 mb-2'>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className='text-white-50 w-500'>Name</TableCell>
            {requestType !== 5 && (
              <TableCell className='text-white-50 w-800'>Message</TableCell>
            )}
            <TableCell className='text-white-50 w-100'>File</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {message.map(val => (
            <TableRow key={val.id}>
              <TableCell>{val.name}</TableCell>
              {requestType !== 5 && (
                <TableCell>
                  <pre>{val.message}</pre>
                </TableCell>
              )}
              <TableCell width='300'>
                {taskSlug && taskSlug !== 'demo-stinger-production' && (
                  <DemoStingerFileUpload
                    id={val.id}
                    setMessage={setMessage}
                    message={val}
                  />
                )}
                {taskSlug &&
                  taskSlug === 'demo-stinger-production' &&
                  (val.file_url ? (
                    <MusicPreviewBtn
                      id={val.id}
                      url={val.file_url}
                      track_name={val.name}
                      track_artist={val.message || ''}
                    />
                  ) : (
                    <Tooltip title='In Progress'>
                      <MusicPreviewBtnDisable />
                    </Tooltip>
                  ))}
              </TableCell>
              {val.file_url && taskSlug === 'demo-stinger-production' && (
                <TableCell>
                  <IconButton
                    component='a'
                    href={val.file_url}
                    target='_blank'
                    download={val.file_name}
                    rel='noreferrer'>
                    <DownloadIcon />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default DemoStingerAddAudio;
